import { render, staticRenderFns } from "./PageDictionaries.vue?vue&type=template&id=55c4da2a&"
import script from "./PageDictionaries.vue?vue&type=script&lang=js&"
export * from "./PageDictionaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c4da2a')) {
      api.createRecord('55c4da2a', component.options)
    } else {
      api.reload('55c4da2a', component.options)
    }
    module.hot.accept("./PageDictionaries.vue?vue&type=template&id=55c4da2a&", function () {
      api.rerender('55c4da2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dictionaries/PageDictionaries.vue"
export default component.exports